import PrescriptionView from './PrescriptionView'

export * from './PrescriptionView'

export default PrescriptionView
